import { render } from "./DeleteCuratorDialog.vue?vue&type=template&id=e6042bbe&scoped=true"
import script from "./DeleteCuratorDialog.vue?vue&type=script&lang=js"
export * from "./DeleteCuratorDialog.vue?vue&type=script&lang=js"

import "./DeleteCuratorDialog.vue?vue&type=style&index=0&id=e6042bbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6042bbe"]])

export default __exports__